import { Component, Input, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { Currency, CurrencyService } from "../../services/currencyService";
import { UserService } from "src/app/services/authentication/user.service";

@Component({
  selector: "app-currency-selector",
  templateUrl: "./currency-selector.component.html",
  styleUrls: ["./currency-selector.component.scss"],
})
export class CurrencySelectorComponent implements OnInit, OnChanges {
  defaultCurrency = Currency.USD;
  public isCurrencySwitcherEnabled = false;
  //An API change is required. Currently there is no information indicating which brand should have the currency switcher.
  static brandsWithCurrencySwitcher = ["EthanAllen"];

  @Input() pimTenantId: string;

  constructor(
    private currencyService : CurrencyService,
    public userService: UserService
  ) {}

  ngOnInit(): void {
    this.isCurrencySwitcherEnabled = CurrencySelectorComponent.hasCurrencySwitcherFor(this.pimTenantId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["pimTenantId"]) this.isCurrencySwitcherEnabled = CurrencySelectorComponent.hasCurrencySwitcherFor(this.pimTenantId);
  }

  public static hasCurrencySwitcherFor(pimTenantId?: string): boolean {
    return !!pimTenantId && CurrencySelectorComponent.brandsWithCurrencySwitcher.includes(pimTenantId);
  }

  public currencyItems: Currency;

  get currency(): Currency {
    return this.currencyService.currency;
  }

  get availableCurrencies(): Currency[] {
    return this.currencyService.availableCurrencies;
  }

  public onChangeCurrency(value: Currency): void {
    this.currencyService.setCurrency(value);
  }

  public getCurrencyPlaceholder(currency: Currency): string {
    return CurrencyService.currencyInfoMap.get(currency);
  }
}
